import React from 'react';
import {MasterLayout} from 'layout';
import { header } from 'constants/table';
import {ThongKeBaoCao} from 'api';
import { Button } from '@blueprintjs/core';
import DataTable from 'components/data-table';
import {
  DropDownChonLoaiQuyThongKe,
  DropDownChonLoaiNamThongKe,
  DropDownChonLoaiThangThongKe,
} from 'components/tt-forms';
import { ShowIf } from 'components/utils';
import {RowItemBaoCaoDinhKy} from './datatable';
import {DropDown, DatePicker} from 'components/tt-forms/common';
import {connect} from 'react-redux';

class BaoCaoDinhKy extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      searchLoading: false,
      loaiKy: 'THEO_QUY',
      tuNgay: '',
      denNgay: '',
      quy: this.getQuy((new Date()).getMonth()+1),
      year: (new Date()).getFullYear(),
      month: (new Date()).getMonth()+1,
      tableLoading: false,
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      kyBaoCaoList: []
    }
  }

  componentDidMount() {
    if(this.props.goBack) {
      let dataSearch = this.props.dataSearch;
      this.state.pageData.number = dataSearch.page || 0;
      this.state.pageData.size = dataSearch.size || 10;
      this.state.loaiKy = dataSearch.loaiKy || 'THEO_QUY'
      this.state.quy = dataSearch.quy || this.getQuy((new Date()).getMonth()+1);
      this.state.year = dataSearch.year || (new Date()).getFullYear();
      this.state.month = dataSearch.month || (new Date()).getMonth()+1;
      this.setState({...this.state});
      this.getListData(false, true);
    } else {
      this.getListData();
    }
    this.getKyBaoCaoData();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.goBack) {
      let dataSearch = nextProps.dataSearch;
      this.state.pageData.number = dataSearch.page || 0;
      this.state.pageData.size = dataSearch.size || 0;
      this.state.loaiKy = dataSearch.loaiKy || 'THEO_QUY'
      this.state.quy = dataSearch.quy || this.getQuy((new Date()).getMonth()+1);
      this.state.year = dataSearch.year || (new Date()).getFullYear();
      this.state.month = dataSearch.month || (new Date()).getMonth()+1;
      this.setState({...this.state});
      this.getListData(false, true);
    }
  }

  getQuy(month) {
    if (month > 0 && month < 4) {
      return 1;
    } else if (month > 3 && month < 7) {
      return 2;
    } else if (month > 6 && month < 10) {
      return 3;
    } else if (month > 9 && month < 13) {
      return 4;
    }
  }

  getKyBaoCaoData() {
    ThongKeBaoCao.actions.getKyBaoCao.request().then(res => {
      if (res.data) {
        this.setState({kyBaoCaoList: res.data});
      } else {
        this.setState({kyBaoCaoList: []});
      }
    });
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getListData(false, true);
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.getListData(false, true);
  }

  getListData(isSearch, pageClick) {
    this.props.dispatch({type: 'BCDK_RESET_GO_BACK'});
    if (isSearch) {
      this.state.pageData = {
        number: 0,
        size: 10,
        totalElements: 0
      };
    }

    let params = {
      loaiKy: this.state.loaiKy,
      page: this.state.pageData.number,
      size: this.state.pageData.size
    }

    if (this.state.loaiKy != 'TUY_CHON' && this.state.year) {
      params.year = this.state.year
    }
    if (this.state.loaiKy == 'THEO_QUY' && this.state.quy) {
      params.quy = this.state.quy
    }
    if (this.state.loaiKy == 'THEO_THANG' && this.state.month) {
      params.month = this.state.month
    }
    if (this.state.loaiKy === 'TUY_CHON' && this.state.tuNgay) {
      params.tuNgay = this.state.tuNgay;
    }
    if (this.state.loaiKy === 'TUY_CHON' && this.state.denNgay) {
      params.denNgay = this.state.denNgay;
    }
    if (isSearch || pageClick) {
      this.props.dispatch({type: 'BCDK_UPDATE_DATA_SEARCH', dataSearch: params});
    }
    ThongKeBaoCao.actions.getBaoCaoDinhKy.request(null, params).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({
          data: res.data._embedded.baoCaoDonVis,
          pageData: res.data.page
        });
      } else {
        this.setState({
          data: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          }
        });
      }
    });
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      });
    } else {
      this.setState({
        [name]: e
      });
    }
  }

  onChange(name, e) {
   if (name == 'loaiKy') {
      this.setState({
        [name]: e.target.value,
        tuNgay: '',
        denNgay: '',
        year: (new Date()).getFullYear(),
        month: 1,
        quy: 1
      })
    } else {
      this.setState({
        [name]: e.target.value
      })
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container wrap-block" ref='thongKeBaoCao'>
          <div className="top-content">
            <div className="left-content">
                <p className="title-18"><i className="tt tt-thongke"></i>Báo cáo định kỳ</p>
            </div>
          </div>
          <div className="bottom-content thongke-content">
            <div className="row pl25 pr25 pt15 super-search">
              <div className='col-83 no-gutter'>
                <DropDown className='col-25' label="Kỳ báo cáo" options={this.state.kyBaoCaoList} keyName="giaTri" valueName="ten" placeholder={null} selectedValue={this.state.loaiKy} onChange={this.onChange.bind(this, 'loaiKy')}/>
                {
                  this.state.loaiKy != 'TUY_CHON' &&
                  <DropDownChonLoaiNamThongKe className='col-25' placeholder={null} onChange={this.onChange.bind(this, 'year')} selectedValue={this.state.year}/>
                }
                <ShowIf condition={this.state.loaiKy == 'THEO_QUY'}>
                  <DropDownChonLoaiQuyThongKe className='col-25' placeholder={null} onChange={this.onChange.bind(this, 'quy')} selectedValue={this.state.quy}/>
                </ShowIf>
                <ShowIf condition={this.state.loaiKy == 'THEO_THANG'}>
                  <DropDownChonLoaiThangThongKe className='col-25' placeholder={null} onChange={this.onChange.bind(this, 'month')} selectedValue={this.state.month}/>
                </ShowIf>
                <ShowIf condition={this.state.loaiKy === 'TUY_CHON'}>
                  <DatePicker className='col-25' label='Từ ngày' endDate={ this.state.denNgay } onChange={this.handleChangeDate.bind(this, 'tuNgay')} value={this.state.tuNgay} require={true} bindValidator={this} channel="formTaoDon"/>
                  <DatePicker className='col-25' label='Đến ngày' startDate={ this.state.tuNgay } onChange={this.handleChangeDate.bind(this, 'denNgay')} value={this.state.denNgay} require={true} bindValidator={this} channel="formTaoDon"/>
                </ShowIf>
              </div>
              <div className='col-16 btn-thongke clear-right'>
                <Button className={this.state.tableLoading ? (this.state.searchLoading ? 'btn-green tt-search btn-loading-inline' : 'btn-green tt-search btn-disable') : 'btn-green tt-search'} text="Xem kết quả" onClick={this.getListData.bind(this, true)}/>
              </div>
            </div>
            <div className="col-100 no-gutter pt5">
              <span className="line-border"></span>
            </div>
            <div className="wrap-table clear-left">
              <DataTable
                header={header.baoCaoDinhKy}
                dataList={this.state.data}
                pageData={this.state.pageData}
                parent={this}
                hideExport
                search={this.state.searchLoading}
                tableLoading={this.state.tableLoading}
              >
                <RowItemBaoCaoDinhKy/>
              </DataTable>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

BaoCaoDinhKy.defaultProps = {
  validators: {
    formTaoDon: []
  },
  type: 'TIEP_CONG_DAN',
  dataSearch: {},
  goBack: false
}

function BindStateToProps(state) {
  return {
    dataSearch: state.baoCaoDinhKy.dataSearch,
    goBack: state.baoCaoDinhKy.goBack
  }
}

export default connect(BindStateToProps)(BaoCaoDinhKy);



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-dinh-ky/BaoCaoDinhKy.jsx